import React from "react";
import cx from "classnames";

interface Props {
  isSelected?: boolean;
  onClick?: () => void;
}

const ImageNavButton = ({ isSelected, onClick }: Props) => {
  return (
    <button
      className={cx(
        "h-1.5 w-1.5 rounded-full bg-white/40 transition-all ease-in-out hover:bg-white/80",
        {
          "w-4 bg-white/80": isSelected,
        }
      )}
      onClick={onClick}
    />
  );
};

export default ImageNavButton;
